<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-stop-recording-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm6.2 13a2.8 2.8 0 012.8 2.8v12.4a2.8 2.8 0 01-2.8 2.8H17.8a2.8 2.8 0 01-2.8-2.8V17.8a2.8 2.8 0 012.8-2.8h12.4z"/></svg>
</template>
<script>

export default {
  name: 'IconStopRecordingFill',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
